import { hashFromPath, loadOrder, selectCheckout, setMouseflowWizardVersion } from './variant'

// Žiadne importy štýlov ani aplikácií pred rozhodnutím. Obe UI sú oddelené.
// Košík sa vyberá podľa objednávky, preto ju načítame skôr než aplikáciu (tá si ju načíta znova).
async function start() {
  const hash = hashFromPath(location.pathname)
  const order = hash ? await loadOrder(hash) : null
  const variant = selectCheckout(location.search, order)
  document.documentElement.dataset.checkoutVersion = variant
  setMouseflowWizardVersion(variant, window)
  // Dva samostatné príkazy s await: pri ternárnom výraze `void import(a) / import(b)` minifikátor spojil
  // obe volania a Vite pribalil CSS len jedného košíka (nový košík sa zobrazil bez vlastných štýlov).
  if (variant === 'new') {
    await import('../checkout-next/src/main')
    return
  }
  await import('../src/main')
}

void start()
